function slugify(input: string): string {
  return input
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export function makeStableToken(value: unknown, fallback: string): string {
  const source = String(value ?? '').trim()
  if (!source) return fallback

  const slug = slugify(source)
  return slug || fallback
}

export function buildStableTestId(prefix: string, parts: unknown[]): string {
  const tokens = parts.map((part, index) => makeStableToken(part, `p${index}`))
  return [prefix, ...tokens].join('-')
}
